<mat-card *ngIf="data">
  <mat-card-content>
    <h2 class="info-title">{{data.title}}</h2>

    <div class="features-list">
      <app-portal-promoted-feature
        *ngFor="let item of data.items"
        [title]="item.title" [iconUrl]="item.icon.content.umbracoFile">
        {{item.description}}  
      </app-portal-promoted-feature>
    </div>
  </mat-card-content>
</mat-card>
